const range = require('lodash/range');
const plugin = require('tailwindcss/plugin');

// 2~6까지의 cols에 해당하는 inner border util 추가
const gridInnerBorderUtils = plugin(function ({addUtilities}) {
  addUtilities(
    range(1, 7).map(num => {
      return {
        [`.grid-inner-border-cols${num}`]: {
          '& > *': {
            'border-bottom-style': 'solid',
            'border-right-style': 'solid',
            'border-left': 'none',
            'border-top': 'none',
          },
          [`& > *:nth-last-of-type(-n+${num})`]: {
            'border-bottom': 'none',
          },
        },
      };
    })
  );
});

module.exports = gridInnerBorderUtils;
